import React, { Component } from 'react';
import './UnitMarkerKey.css';
import ParameterErrors from '../errors/ParameterErrors';
import PlotStatus from '../site/PlotStatus';
import HashSource from '../core/HashSource';
const{throwNotProvided} = ParameterErrors;
export default class UnitMarkerKey extends Component {
	constructor(props){
		super(props)
		const {hasKeyHeading}=props;
		this._hasKeyHeading = hasKeyHeading;
		this.load = this.load.bind(this);
		this.state ={plotsArray:null};
	}
	load({siteJson, plotsArray}){
		this.setState({plotsArray:plotsArray?plotsArray:siteJson.units.getPlotsArray()});
	}
	render() {
		const plotStatusesForPlots = [];
		const plotsArray = this.state.plotsArray;
		if(plotsArray){
			plotsArray.forEach(plot=>{
				if(plotStatusesForPlots.indexOf(plot.status)<0)
					plotStatusesForPlots.push(plot.status);
			});
		}
		plotStatusesForPlots.sort((firstPlotStatus, secondPlotStatus)=>{
			const firstPlotStatusDescription = PlotStatus.getDescription(firstPlotStatus);
			const secondPlotStatusDescription=PlotStatus.getDescription(secondPlotStatus);
			if(firstPlotStatusDescription===secondPlotStatusDescription)return 0;
			return firstPlotStatusDescription>secondPlotStatusDescription?1:-1;
		});
		const entries = plotStatusesForPlots.map((plotStatus)=><li key={HashSource.next()} className="entry"> <div className={"marker "+PlotStatus.getCssName(plotStatus)}></div>
			{PlotStatus.getDescription(plotStatus)}</li>);
		const heading = this._hasKeyHeading?'Key':null;
		const className = "unit-marker-key"+(this._hasKeyHeading?' has-key-heading':'');
		return (<div className={className}>{heading}<ul className="entries">
		{entries}
		</ul></div>)
	}
}
